export default __webpack_public_path__ + "static/media/c6.e76085eb.png";